module.exports = "https://static.wmbcdn.com/uniweb/images/fdcfeae113601a78ce50d8665a35ce5c.svg";